import PrivacyPolicy from "../components/PrivacyPolicy";

function PrivacyPage() {
  return <PrivacyPolicy />;
}

export default PrivacyPage;
